import { BuyLowSellHighPlayer } from "../model/BuyLowSellHighPlayer";

interface BuyLowSellHigh {
    buyLow: BuyLowSellHighPlayer[];
    sellHigh: BuyLowSellHighPlayer[];
}

export const convertBuyLowSellHigh: (data: any[]) => BuyLowSellHigh = (data: any) => {
    const result = [...data];
    result.shift();
    result.shift();
    const buyLow = result.map(e => {
        if (e[0] && e[1]) {
            return {
                name: e[0],
                remark: e[1]
            } as BuyLowSellHighPlayer;
        }
    });
    const sellHigh = result.map(e => {
        if (e[2] && e[3]) {
            return {
                name: e[2],
                remark: e[3]
            } as BuyLowSellHighPlayer;
        }
    }).filter(e => e);
    return {
        buyLow: buyLow as BuyLowSellHighPlayer[],
        sellHigh: sellHigh as BuyLowSellHighPlayer[]
    }
}